module.exports = __webpack_public_path__ + "img/logo-footer.0bf39e5a.svg";